import React from 'react'
import { useEffect, useState } from 'react';
import { makeLoginRequest, getUserConfigRequest , logout} from '../../utils/requestHandler';

import { Grid, Button, Form } from 'semantic-ui-react'
import backgroundImage from '../../images/login-background.jpg';


const Login = () => {

  const [error, setError] = useState('');

  const [loadConfig, setLoadConfig] = useState(false);


  const sendLogin = async (username, password, showError = true) => {

    const response = await makeLoginRequest(username, password);
    
    console.log('login response', response)
    localStorage.setItem('username', username);

    if (showError && (!response || response.error)) {
      setError(response ? response.error : '');
      return
    }
    window.location.reload()
}



  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const disableLoginButton = () => { return (username !== "" && password !== "") ? false : true}

  return (
    <>
    
      <div className="puzzel-landing-image">
        <div className="puzzel-overlay"></div>
        <Grid style={{ height: "100vh" }} verticalAlign="middle" textAlign="center">
          <Grid.Column mobile={1} tablet={4} computer={4}></Grid.Column>
          <Grid.Column mobile={14} tablet={6} computer={6}>
            <Form
              onSubmit={() => { 
                sendLogin(username, password) ;
              }}
            >
              <Form.Input
                placeholder='Användarnamn'
                icon="user"
                type='input'
                value={username}
                onChange={(e, data) => { setUsername(data.value) }}
              />

              <Form.Input
                placeholder='Lösenord'
                icon="key"
                type='password'
                value={password}
                onChange={(e, data) => { setPassword(data.value) }}
              />

              <Button disabled={disableLoginButton()} type='submit' color="teal" >Logga in</Button>
              {error && ( <div className="puzzel-login-error">{error}</div>)}
            </Form>
          </Grid.Column>
          <Grid.Column mobile={1} tablet={4} computer={4}></Grid.Column>
        </Grid>
      </div>
    </>
  )
}

export default Login;